import FrontText from "@/Components/Front/FrontText";
import FrontLayout from "@/Layouts/System/FrontLayout";
import { Icon } from "@iconify/react";
import { Trans, useTranslation } from "react-i18next";
import FrontOurTeamCards from "@/Components/Front/Blocks/FrontOurTeamCards";
import FrontBasicHero from "@/Components/Front/Blocks/Hero/FrontBasicHero";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import Column from "@/Components/Grid/Column";
import FrontStandardContact from "@/Components/Front/Forms/Contact/FrontStandardContact";
import FrontWarehousesToRent from "@/Components/Front/Blocks/FrontWarehousesToRent";
import makePhoneNumber from "@/Helpers/makePhoneNumber";
import FrontSeoMetaTags from "@/Components/Front/Partials/FrontSeoMetaTags";

const Contact = ({ seo, agents }) => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.resolvedLanguage;

    // const order = [
    //     "Michał Chodecki",
    //     "Małgorzata Papaj",
    //     "Małgorzata Włochal",
    //     "Bartosz Czuba",

    //     "Halina Sitko",
    //     "Robert Katzor",
    //     "Magdalena Matusik",

    //     "Magdalena Klank",
    //     "Maciej Grzybowski",
    //     "Emilia Fluderska",

    //     "Michał Naworski",
    //     "Mateusz Porębiński",

    //     "Marcin Hosaniak",
    //     "Rafał Bochenek",
    //     "Aleksandra Drewnowska",
    // ];

    // const sortedAgents = [...agents].sort((a, b) => {
    //     return order.indexOf(a.name) - order.indexOf(b.name);
    // });

    return (
        <FrontLayout
            breadcrumbs={[{ title: t("breadcrumbs.contact"), current: true }]}
        >
            <FrontSeoMetaTags seo={seo} />

            <FrontBasicHero heading={t("contact_page.heading")} />

            <section id="contact" className="pt-[30px] md:pt-10 relative">
                <Container>
                    <div className="content-[''] absolute top-0 left-0 w-full h-[400px] bg-[#25273A] z-[-1] md:hidden"></div>
                    <FrontText
                        textSize="16/20-m-same"
                        className={`md:hidden uppercase mb-[30px] text-white`}
                    >
                        {t("contact_page.contact_form")}
                    </FrontText>

                    <Row>
                        <Column xl={9} lg={9} className="lg:pr-15">
                            <FrontStandardContact referer="Kontakt" />
                        </Column>
                        <Column xl={3} lg={3}>
                            <div className="lg:grid flex lg:grid-cols-1 flex-wrap lg:grid-rows-3 sm:gap-x-8 lg:h-full w-full lg:gap-y-c53 gap-y-10 lg:mt-0 mt-10">
                                {/* =================== [Box Phone] =================== */}
                                <a
                                    href={makePhoneNumber(
                                        t("contact_page.boxPhone"),
                                    )}
                                    title={t("contact_page.boxPhone")}
                                    className="transition-all ease-in-out duration-300 [&:hover_.hover-text-dark-blue-standard]:text-dark-blue-standard [&:hover_.hover-bg-white]:bg-white hover:bg-dark-blue-standard [&:hover_.hover-yellow]:text-yellow [&:hover_.hover-blue]:text-dark-blue-standard [&:hover_.hover-white]:text-white lg:h-full lg:w-full sm:w-[calc(50%_-_1rem)] w-full shadow-gray-box flex items-center xl:gap-x-5 gap-x-4 xl:pl-18 py-4 xl:pr-3 px-6"
                                >
                                    <div className="w-[42px] h-[42px] bg-dark-blue hover-bg-white flex items-center justify-center shrink-0 rounded-full">
                                        <Icon
                                            icon="material-symbols:call"
                                            className="text-white hover-text-dark-blue-standard"
                                        />
                                    </div>
                                    <FrontText
                                        textSize="16/20"
                                        className="text-dark-blue"
                                    >
                                        <p className="hover-yellow">
                                            <span className="font-semibold">
                                                <Trans i18nKey="contact_page.boxPhoneLabel" />
                                            </span>
                                        </p>
                                        <p className="hover-white">
                                            <Trans i18nKey="contact_page.boxPhone" />
                                        </p>
                                    </FrontText>
                                </a>

                                {/* =================== [Box Mail] =================== */}
                                <a
                                    href={`mailto:${t("contact_page.boxMail")}`}
                                    title={t("contact_page.boxMail")}
                                    className="transition-all ease-in-out duration-300 [&:hover_.hover-text-dark-blue-standard]:text-dark-blue-standard [&:hover_.hover-bg-white]:bg-white hover:bg-dark-blue-standard [&:hover_.hover-yellow]:text-yellow [&:hover_.hover-blue]:text-dark-blue-standard [&:hover_.hover-white]:text-white lg:h-full lg:w-full sm:w-[calc(50%_-_1rem)] w-full shadow-gray-box flex items-center xl:gap-x-5 gap-x-4 xl:pl-18 py-4 xl:pr-3 px-6"
                                >
                                    <div className="w-[42px] h-[42px] bg-dark-blue hover-bg-white flex items-center justify-center shrink-0 rounded-full">
                                        <Icon
                                            icon="ic:outline-email"
                                            className="text-white hover-text-dark-blue-standard"
                                        />
                                    </div>
                                    <FrontText
                                        textSize="16/20"
                                        className="text-dark-blue"
                                    >
                                        <p className="hover-yellow">
                                            <span className="font-semibold">
                                                <Trans i18nKey="contact_page.boxMailLabel" />
                                            </span>
                                        </p>
                                        <p className="hover-white">
                                            <Trans i18nKey="contact_page.boxMail" />
                                        </p>
                                    </FrontText>
                                </a>

                                {/* =================== [Box Address] =================== */}
                                <a
                                    href="https://goo.gl/maps/ZsWRyZ8JctorHsXw7"
                                    title="Savills"
                                    target="_blank"
                                    className="transition-all ease-in-out duration-300 [&:hover_.hover-bg-white]:bg-white [&:hover_.hover-fill-white]:fill-white [&:hover_.hover-fill-dark-blue-standard]:fill-dark-blue-standard hover:bg-dark-blue-standard [&:hover_.hover-yellow]:text-yellow [&:hover_.hover-blue]:text-dark-blue-standard [&:hover_.hover-white]:text-white lg:h-full lg:w-full sm:w-1/2 w-full mx-auto shadow-gray-box flex items-center xl:gap-x-5 gap-x-4 xl:pl-18 py-4 xl:pr-3 px-6"
                                >
                                    <div className="w-[42px] h-[42px] bg-dark-blue hover-bg-white flex items-center justify-center shrink-0 rounded-full">
                                        <svg
                                            width="14"
                                            height="19"
                                            viewBox="0 0 14 19"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <ellipse
                                                cx="6.57728"
                                                cy="5.75481"
                                                rx="6.00502"
                                                ry="5.75481"
                                                fill="white"
                                                className="hover-fill-dark-blue-standard"
                                            />
                                            <ellipse
                                                cx="6.57632"
                                                cy="17.5387"
                                                rx="5.11538"
                                                ry="1.46154"
                                                fill="white"
                                                className="hover-fill-dark-blue-standard"
                                            />
                                            <path
                                                d="M6.57737 17.5386L0.881594 7.67319L12.2732 7.67319L6.57737 17.5386Z"
                                                fill="white"
                                                className="hover-fill-dark-blue-standard"
                                            />
                                            <circle
                                                cx="6.57752"
                                                cy="5.48084"
                                                r="3.28846"
                                                fill="#051D41"
                                                className="hover-fill-white"
                                            />
                                        </svg>
                                    </div>
                                    <FrontText
                                        textSize="16/20"
                                        className="text-dark-blue"
                                    >
                                        <p className="hover-yellow">
                                            <span className="font-semibold">
                                                <Trans i18nKey="contact_page.boxAddressLabel" />
                                            </span>
                                        </p>
                                        <p className="hover-white">
                                            <Trans i18nKey="contact_page.boxAddress" />
                                        </p>
                                    </FrontText>
                                </a>
                            </div>
                        </Column>
                    </Row>
                </Container>
            </section>

            <section
                id="team"
                className="pt-20 xl:pb-25 lg:pb-20 md:pb-14 pb-5"
            >
                <FrontOurTeamCards
                    agents={agents}
                    heading={t("contact_page.our_agents")}
                />
            </section>

            {currentLang === "pl" && (
                <section id="warehouses" className="pt-10 pb-14">
                    <FrontWarehousesToRent />
                </section>
            )}

            {/* <section id="where-we-are" className="pb-30">
                <FrontWhereWeAre/>
            </section> */}
        </FrontLayout>
    );
};

export default Contact;
